import React from 'react'
import Contractviewform from '../../components/contractreportcomponents/Contractviewform'

function  Contractoutview({renderPageContent}) {
    return (
        <>
                        <Contractviewform renderPageContent={renderPageContent}/>
        </>
    )
}

export default  Contractoutview